const Vision = () => {
  // Texts roughly equal length so cards align visually
  const points = [
    {
      k: "USP 01",
      title: "Fassade ab Werk.",
      desc: "Komplettbauteil inkl. Fassadenschicht — werkseitig vorgefertigt. Eine Bauweise, die bislang kaum jemand industriell beherrscht.",
    },
    {
      k: "USP 02",
      title: "Laubholz statt Monokultur.",
      desc: "Gezielter Einsatz von Laubhölzern — für mehr Biodiversität und deutlich überlegene bauphysikalische Eigenschaften pro Schicht.",
    },
    {
      k: "USP 03",
      title: "Wohngesundheit.",
      desc: "Schlanker Aufbau, diffusionsoffen, frei von synthetischen Leimen — ein Innenraumklima, das Schichtbauweisen nicht erreichen.",
    },
  ];

  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-24 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <span data-testid="vision-eyebrow" className="label-eyebrow">
              Die Vision
            </span>
            <h2 className="font-heading mt-6 text-4xl sm:text-5xl font-light leading-[1.05] tracking-tighter">
              Ehrlicher Holzbau.
              <br />
              <span className="text-white/40">Endlich.</span>
            </h2>
          </div>

          <div className="md:col-span-7 md:pt-4">
            <p className="text-lg text-white/70 leading-relaxed font-light">
              Holzbau gilt als nachhaltig — meist ist er es nicht.
              Holzrahmenbau und BSP stecken voller synthetischer Leime, Folien
              und Verbundwerkstoffe. Oft nur ein Holz‑Mantel um Chemie.
            </p>
            <p className="mt-6 text-lg text-white/70 leading-relaxed font-light">
              <span className="text-[#c88a53]">MONOWOOD</span> ist anders:
              schlank, schadstofffrei, ehrlich. Ein All-Wood-System, werkseitig
              vorgefertigt. Schneller. Gesünder. Wirklich nachhaltig — statt nur
              so beworben.
            </p>
          </div>
        </div>

        <div className="rule mt-20 mw-line" />

        <div
          data-testid="vision-bento"
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 items-stretch"
        >
          {points.map((p, i) => (
            <div
              key={i}
              data-testid={`vision-point-${i}`}
              className="bg-[#0a0a0a] p-8 md:p-10 group hover:bg-[#0e0e0e] transition-colors flex flex-col h-full"
            >
              <div className="text-[0.7rem] tracking-[0.28em] uppercase text-[#c88a53] font-bold">
                {p.k}
              </div>
              <div className="mt-6 font-heading text-2xl text-white font-medium leading-snug">
                {p.title}
              </div>
              <p className="mt-3 text-sm text-white/55 leading-relaxed flex-1">
                {p.desc}
              </p>
              <div className="mt-8 text-[0.65rem] tracking-[0.3em] uppercase text-white/30 font-mono-num">
                0{i + 1} / 03
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vision;
